export function filterByRegionIntersection(employees: any[], originRegionIds: any[]) {
  if (!Array.isArray(originRegionIds) || originRegionIds.length === 0) {
    return employees;
  }

  return employees.filter((empl: any) => {
    const employeeRegionIds = empl.regions.map((region: { id: any; }) => region.id)

    let doesIntersect = false;

    originRegionIds.forEach(el => {
      if (employeeRegionIds.includes(el)) {
        doesIntersect = true;
      }
    })

    return doesIntersect;
  });
};
